import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/jobs/changeOrdersReportActions'
import { DatePicker, Button, Form, Checkbox, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/jobs/change-orders/ListItem'
import moment from 'moment'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config
const { RangePicker } = DatePicker

const propTypes = {}
const FormItem = Form.Item
const CheckboxGroup = Checkbox.Group

class ChangeOrdersReportContainer extends Component {
  constructor(props) {
    super(props)

    const filter = [
      moment('2018-01-01', 'YYYY-MM-DD').startOf('month'),
      moment(new Date(), 'YYYY-MM-DD').endOf('month')
    ]

    this.state = {
      filter,
      checkedStatusList: [],
      checkAllStatus: false,
      plainStatusOptions: ['Open', 'Signed', 'Rejected']
    }

    // get job list
    this.props.changeOrdersReportGetJobList({})

    // get organization list
    this.props.changeOrdersReportGetOrganizationList({})
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  onChangeStatusCheckboxGroup = checkedStatusList => {
    this.setState({
      checkedStatusList,
      checkAllStatus: checkedStatusList.length === this.state.plainStatusOptions.length
    })
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.changeOrdersReportGetFullReport({ filters: values })
    })
  }

  handleJobSearch = _.debounce(value => {
    this.props.changeOrdersReportGetJobList({
      filters: {
        name: value
      }
    })
  }, 500)

  handleOrganizationSearch = _.debounce(value => {
    this.props.changeOrdersReportGetOrganizationList({
      filters: {
        name: value
      }
    })
  }, 500)

  onCheckAllStatusesChange = e => {
    const { form } = this.props

    form.setFieldsValue({
      statuses: e.target.checked ? this.state.plainStatusOptions : []
    })

    this.setState({
      checkedStatusList: e.target.checked ? this.state.plainStatusOptions : [],
      checkAllStatus: e.target.checked
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      if (values.date_range[0] && values.date_range[1]) {
        params.startDate = moment(values.date_range[0]).format('YYYY-MM-DD')
        params.endDate = moment(values.date_range[1]).format('YYYY-MM-DD')
      }

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/jobs/change-orders/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const jobListData = _.get(this.props, 'changeOrdersReportActions.jobList.data')
    const loadingJobList = _.get(this.props, 'changeOrdersReportActions.loadingJobList')

    const organizationListData = _.get(
      this.props,
      'changeOrdersReportActions.organizationList.data'
    )
    const loadingOrganizationList = _.get(
      this.props,
      'changeOrdersReportActions.loadingOrganizationList'
    )

    const loadingFullReport = _.get(this.props, 'changeOrdersReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'changeOrdersReportActions.fullReport.data')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Change Orders</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-4">
              <div className="row">
                <div className="col-10">
                  <FormItem label="Select the date range:">
                    {getFieldDecorator('date_range', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a value'
                        }
                      ],
                      initialValue: this.state.filter
                    })(<RangePicker onChange={this.onChange} />)}
                  </FormItem>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="row">
                <div className="col-10">
                  <Spin spinning={loadingJobList}>
                    <FormItem label="Job">
                      {getFieldDecorator('job_id', {})(
                        <AutoComplete
                          onChange={this.handleJobSearch}
                          dataSource={convertToOption(jobListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Job"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
              <div className="row">
                <div className="col-10">
                  <Spin spinning={loadingOrganizationList}>
                    <FormItem label="Company">
                      {getFieldDecorator('organization_id', {})(
                        <AutoComplete
                          onChange={this.handleOrganizationSearch}
                          dataSource={convertToOption(organizationListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Company"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
            <div className="col-4">
              <FormItem label="Statuses:">
                {getFieldDecorator('statuses', {
                  initialValue: this.state.checkedStatusList
                })(
                  <CheckboxGroup
                    options={this.state.plainStatusOptions}
                    onChange={this.onChangeStatusCheckboxGroup}
                    className="open-container-row"
                  />
                )}
              </FormItem>
              <div style={{ borderTop: '1px solid #E9E9E9' }}>
                <Checkbox
                  indeterminate={this.state.indeterminate}
                  onChange={this.onCheckAllStatusesChange}
                  checked={this.state.checkAllStatus}
                >
                  Check all
                </Checkbox>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ changeOrdersReportActions, authentication }, ownProps) => ({
  changeOrdersReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

ChangeOrdersReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(ChangeOrdersReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/jobs/ChangeOrdersReportContainer.js